export const SET_USER = 'auth/SET_USER'
export const LOGOFF = 'auth/LOGOFF'
export const REFRESH_TOKENS = 'auth/REFRESH_TOKENS'

const INITIAL_STATE = { user: null }

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_USER:
            return { ...state, user: action.payload }
        case LOGOFF:
            return { ...state, ...INITIAL_STATE }
        case REFRESH_TOKENS:
            return state.user && { ...state, user: { ...state.user, ...action.payload } }
        default:
            return state
    }
}

export const setUser = payload => ({ type: SET_USER, payload })
export const refreshTokens = payload => ({ type: REFRESH_TOKENS, payload })
export const logoff = () => ({ type: LOGOFF })



// WEBPACK FOOTER //
// ./src/ducks/Auth.js